import { render, staticRenderFns } from "./DailyTasks.vue?vue&type=template&id=c4a0743a&"
import script from "./DailyTasks.vue?vue&type=script&lang=js&"
export * from "./DailyTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports